import { render, staticRenderFns } from "./cardTableBody.vue?vue&type=template&id=01d0c663&"
import script from "./cardTableBody.vue?vue&type=script&lang=js&"
export * from "./cardTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports